import { flow, isEmpty, negate, omit, some, values } from 'lodash/fp';
import { type EventContributor } from '@/types';
import { type FormValues } from './IncidentForm';

export const isIncidentFormValid = (formValues?: FormValues) =>
  flow(
    omit(['time', 'author_id']), //
    values,
    some(negate(isEmpty)),
  )(formValues);

export const normalizeContributorOptions = (
  contributors?: EventContributor[],
) => {
  if (!contributors) return [];

  const options = contributors?.map<{
    label: EventContributor['full_name'];
    value: EventContributor['user_id'];
    user?: EventContributor;
  }>((contributor) => ({
    label: contributor.full_name || '',
    value: contributor.user_id || '',
    user: contributor,
  }));

  options.unshift({ label: '—', value: '' });

  return options;
};
